import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { SPECIAL_OFFER_ROUTES } from 'src/app/core/constants/routes-constants';

@Component({
  selector: 'app-special-offers',
  templateUrl: './campaign-published.component.html',
  styleUrls: ['./campaign-published.component.scss'],
  standalone: false,
})
export class CampaignPublishedComponent {
  constructor(private readonly _router: Router) {}

  redirectToSpecialOffersList() {
    this._router.navigate([SPECIAL_OFFER_ROUTES.ADMIN_SPECIAL_OFFERS]);
  }
}
